import React, { useState } from 'react'
import { CloseIcon, InfoIcon, Text, Title } from '@ntuctech/tangram-web'
import tangramNextConfig from '../../lib/tangramNextConfig'
import styled from 'styled-components'
import Popover from 'react-tiny-popover'
import { trackBcrsInfoButtonClickEvent } from '../../lib/analytics/events/buttonClickEvents/BcrsInfoButtonClickedEvent'

const BcrsInfoButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  width: ${({ $isSmall }) => ($isSmall ? '1rem' : '1.25rem')};
  height: ${({ $isSmall }) => ($isSmall ? '1rem' : '1.25rem')};
  cursor: pointer;
  margin-left: 0.25rem;
  vertical-align: sub;
`
const BcrsInfoIcon = styled(InfoIcon)`
  width: ${({ $isSmall }) => ($isSmall ? '1rem' : '1.25rem')};
  height: ${({ $isSmall }) => ($isSmall ? '1rem' : '1.25rem')};
  color: ${tangramNextConfig.colors.mineshaft500};
`

const BcrsPopoverContainer = styled.div`
  width: 250px;
  background-color: ${tangramNextConfig.colors.primary300};
  padding: 0.75rem;
  border-radius: 0.25rem;
  color: white;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: -0rem;
    width: 1rem;
    height: 1rem;
    left: 117px;
    bottom: -0.5rem;
    border: none;
    border-top: 0.5rem solid ${tangramNextConfig.colors.primary300};
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
  }
`

const BcrsPopoverHeader = styled.div`
  display: flex;
  gap: 0.5rem;
`

const BcrsPopoverCloseButton = styled.div`
  cursor: pointer;
`

const BcrsPopoverCloseIcon = styled(CloseIcon)`
  color: inherit;
  width: 1.5rem;
  height: 1.5rem;
`

export default function BcrsPopover({ isSmall }) {
  const [isShownPopover, setIsShownPopover] = useState(false)

  return (
    <Popover
      isOpen={isShownPopover}
      position={['top', 'right']}
      onClickOutside={() => {
        setIsShownPopover(false)
      }}
      content={
        <BcrsPopoverContainer>
          <BcrsPopoverHeader>
            <Title size="xs" color="inherit">
              Beverage Container Return Scheme
            </Title>
            <BcrsPopoverCloseButton
              data-testid="bcrs_popover_close_icon"
              onClick={() => {
                setIsShownPopover(false)
              }}
            >
              <BcrsPopoverCloseIcon />
            </BcrsPopoverCloseButton>
          </BcrsPopoverHeader>
          <Text size="s" color="inherit">
            Claim your deposit by returning empty containers to any designated
            point.
          </Text>
        </BcrsPopoverContainer>
      }
    >
      <BcrsInfoButton
        $isSmall={isSmall}
        data-testid="bcrs_info"
        aria-label="Refundable container deposit more information icon"
        tabIndex={0}
        role="button"
        onClick={() => {
          setIsShownPopover(true)
          trackBcrsInfoButtonClickEvent()
        }}
      >
        <BcrsInfoIcon $isSmall={isSmall} />
      </BcrsInfoButton>
    </Popover>
  )
}
